export var InstrumentType;
(function (InstrumentType) {
    InstrumentType["CurrencyIso"] = "CurrencyIso";
    InstrumentType["PreciousMetalIso"] = "PreciousMetalIso";
})(InstrumentType || (InstrumentType = {}));
export var CurrencyIso;
(function (CurrencyIso) {
    CurrencyIso["azn"] = "azn";
    CurrencyIso["amd"] = "amd";
    CurrencyIso["byn"] = "byn";
    CurrencyIso["kzt"] = "kzt";
    CurrencyIso["kgs"] = "kgs";
    CurrencyIso["mdl"] = "mdl";
    CurrencyIso["rub"] = "rub";
    CurrencyIso["tjs"] = "tjs";
    CurrencyIso["tmm"] = "tmm";
    CurrencyIso["uzs"] = "uzs";
})(CurrencyIso || (CurrencyIso = {}));
export var PreciousMetalIso;
(function (PreciousMetalIso) {
    PreciousMetalIso["xau"] = "xau";
    PreciousMetalIso["xag"] = "xag";
    PreciousMetalIso["xpt"] = "xpt";
    PreciousMetalIso["xpd"] = "xpd";
})(PreciousMetalIso || (PreciousMetalIso = {}));
const currencySymbols = {
    [CurrencyIso.azn]: '₼',
    [CurrencyIso.amd]: '֏',
    [CurrencyIso.byn]: 'Br',
    [CurrencyIso.kzt]: '₸',
    [CurrencyIso.kgs]: 'c̲',
    [CurrencyIso.mdl]: 'L',
    [CurrencyIso.rub]: '₽',
    [CurrencyIso.tjs]: 'c',
    [CurrencyIso.tmm]: 'm',
    [CurrencyIso.uzs]: 'so’m',
};
export const cisCurrenciesData = {
    [CurrencyIso.azn]: { iso: CurrencyIso.azn, type: InstrumentType.CurrencyIso, symbol: '🇦🇿', name: 'Азербайджанский манат', countryShort: 'Азербайджан', country: 'Азербайджанская Республика', currencySymbol: '₼' },
    [CurrencyIso.amd]: { iso: CurrencyIso.amd, type: InstrumentType.CurrencyIso, symbol: '🇦🇲', name: 'Армянский драм', countryShort: 'Армения', country: 'Республика Армения', currencySymbol: '֏' },
    [CurrencyIso.byn]: { iso: CurrencyIso.byn, type: InstrumentType.CurrencyIso, symbol: '🇧🇾', name: 'Белорусский рубль', countryShort: 'Белоруссия', country: 'Белорусская Республика', currencySymbol: 'Br' },
    [CurrencyIso.kzt]: { iso: CurrencyIso.kzt, type: InstrumentType.CurrencyIso, symbol: '🇰🇿', name: 'Казахстанский тенге', countryShort: 'Казахстан', country: 'Республика Казахстан', currencySymbol: '₸' },
    [CurrencyIso.kgs]: { iso: CurrencyIso.kgs, type: InstrumentType.CurrencyIso, symbol: '🇰🇬', name: 'Киргизский сом', countryShort: 'Киргизия', country: 'Киргизская Республика', currencySymbol: 'c̲' },
    [CurrencyIso.mdl]: { iso: CurrencyIso.mdl, type: InstrumentType.CurrencyIso, symbol: '🇲🇩', name: 'Молдавский лей', countryShort: 'Молдова', country: 'Республика Молдова', currencySymbol: 'L' },
    [CurrencyIso.rub]: { iso: CurrencyIso.rub, type: InstrumentType.CurrencyIso, symbol: '🇷🇺', name: 'Российский рубль', countryShort: 'Россия', country: 'Российская Федерация', currencySymbol: '₽' },
    [CurrencyIso.tjs]: { iso: CurrencyIso.tjs, type: InstrumentType.CurrencyIso, symbol: '🇹🇯', name: 'Таджикский сомони', countryShort: 'Таджикистан', country: 'Республика Таджикистан', currencySymbol: 'c' },
    [CurrencyIso.tmm]: { iso: CurrencyIso.tmm, type: InstrumentType.CurrencyIso, symbol: '🇹🇲', name: 'Туркменский манат', countryShort: 'Туркменистан', country: 'Туркменистан', currencySymbol: 'm' }, // alt = tmt
    [CurrencyIso.uzs]: { iso: CurrencyIso.uzs, type: InstrumentType.CurrencyIso, symbol: '🇺🇿', name: 'Узбекский сум', countryShort: 'Узбекистан', country: 'Республика Узбекистан', currencySymbol: 'so’m' },
};
export const cisCurrenciesDataArray = Object.values(cisCurrenciesData);
const preciousMetals = {
    [PreciousMetalIso.xau]: { iso: PreciousMetalIso.xau, type: InstrumentType.PreciousMetalIso, symbol: '✨', name: 'Золото' },
    [PreciousMetalIso.xag]: { iso: PreciousMetalIso.xag, type: InstrumentType.PreciousMetalIso, symbol: '✨', name: 'Серебро' },
    [PreciousMetalIso.xpt]: { iso: PreciousMetalIso.xpt, type: InstrumentType.PreciousMetalIso, symbol: '✨', name: 'Платина' },
    [PreciousMetalIso.xpd]: { iso: PreciousMetalIso.xpd, type: InstrumentType.PreciousMetalIso, symbol: '✨', name: 'Палладий' },
};
export const instrumentsData = {
    ...cisCurrenciesData,
    ...preciousMetals,
};
export const currencyKeysList = Object.values(CurrencyIso);
export const preciousMetalsKeysList = Object.values(PreciousMetalIso);
export const instrumentKeysList = [...currencyKeysList, ...preciousMetalsKeysList];
const getCurrencyIsoArrayWithIds = (isoArray) => {
    return isoArray.map((iso, index) => ({ id: index, iso }));
};
export const defaultCurrencyKeysListWithIds = getCurrencyIsoArrayWithIds(currencyKeysList);
export const defaultMetalKeysListWithIds = getCurrencyIsoArrayWithIds(preciousMetalsKeysList);
